import cx from "classnames";
import {
  Label,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

import { DEFAULT_INITIAL_WEIGHT_LB } from "../../constants";
import { getEstimatedWeightLossData } from "./utils";

import styles from "./styles.module.scss";

/**
 *
 * @param {object} props
 * @param {number} props.initialWeightLb
 * @param {string} [props.className]
 * @param {string} [props.lineColor]
 * @returns
 */
const WeightLossGraph = ({
  initialWeightLb = DEFAULT_INITIAL_WEIGHT_LB,
  className,
  lineColor = "#11d4d4"
}) => {
  return (
    <div
      className={cx(styles.content, className, {
        [styles.isTest]: window?.ww?.isTest
      })}
      aria-hidden="true"
    >
      <div className={styles.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={getEstimatedWeightLossData(initialWeightLb)}>
            <XAxis dataKey="week" height={40} scale="time" type="number">
              <Label
                position={{ x: 170, y: 44 }}
                value="Weeks"
                className={styles.xAxisLabel}
              />
            </XAxis>
            <YAxis
              dataKey="weight"
              domain={[initialWeightLb * 0.82, initialWeightLb * 1.02]}
              scale="linear"
            >
              <Label
                angle={-90}
                position={{ x: 10, y: 140 }}
                value="Weight (lbs)"
                className={styles.yAxisLabel}
              />
            </YAxis>

            <Line
              dataKey="weight"
              stroke={lineColor}
              strokeWidth={2}
              type="monotone"
              isAnimationActive={window?.ww?.isTest ? false : true}
            />

            <Tooltip
              formatter={value => [`${Math.floor(value)} lb`, "Weight"]}
              labelFormatter={label => `Week: ${label}`}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default WeightLossGraph;
